const INVENTORYLIST = [
  { 'id': 'fridge', 'title': 'Kjøleskap', 'value': 1, 'active': true },
  { 'id': 'stove', 'title': 'Komfyr', 'value': 1, 'active': true },
  { 'id': 'heater', 'title': 'Varmeovn', 'value': 1, 'active': true },
  { 'id': 'dishwasher', 'title': 'Oppvaskmaskin', 'value': 1, 'active': true },
  { 'id': 'washing_machine', 'title': 'Vaskemaskin', 'value': 1, 'active': true },
  { 'id': 'dryer', 'title': 'Tørketrommel', 'value': 0, 'active': false }
]
export default INVENTORYLIST;